export const SHORT_FORM_WEB_EXPERIMENT = 'b2c_txn1366_short_form_web';
